var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6991 10.7009C14.6991 11.3536 14.5056 11.9916 14.143 12.5343C13.7804 13.0769 13.265 13.4999 12.662 13.7497C12.059 13.9995 11.3955 14.0648 10.7553 13.9375C10.1152 13.8101 9.52718 13.4958 9.06567 13.0343C8.60416 12.5728 8.28986 11.9848 8.16253 11.3447C8.0352 10.7045 8.10055 10.041 8.35032 9.43802C8.60009 8.83503 9.02306 8.31964 9.56574 7.95703C10.1084 7.59442 10.7464 7.40088 11.3991 7.40088C11.8325 7.40088 12.2616 7.48624 12.662 7.65208C13.0624 7.81792 13.4261 8.06099 13.7326 8.36743C14.039 8.67386 14.2821 9.03765 14.4479 9.43802C14.6138 9.8384 14.6991 10.2675 14.6991 10.7009Z",
    stroke: "#727477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 10.7018C21.3 18.4018 11.4 25.0018 11.4 25.0018C11.4 25.0018 1.5 18.4018 1.5 10.7018C1.5 8.07611 2.54303 5.55801 4.39964 3.7014C6.25625 1.84479 8.77436 0.801758 11.4 0.801758C14.0256 0.801758 16.5437 1.84479 18.4004 3.7014C20.257 5.55801 21.3 8.07611 21.3 10.7018Z",
    stroke: "#727477",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIcon);
export default __webpack_public_path__ + "static/media/loc-icon.824ae62b291d6a4602347381643f6303.svg";
export { ForwardRef as ReactComponent };